import { render } from "./FullScreenLoading.vue?vue&type=template&id=6798f503&scoped=true"
import script from "./FullScreenLoading.vue?vue&type=script&lang=js"
export * from "./FullScreenLoading.vue?vue&type=script&lang=js"

import "./FullScreenLoading.vue?vue&type=style&index=0&id=6798f503&scoped=true&lang=css"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6798f503"]])

export default __exports__